import { IModuleRoute, RoleTypes, AppRouteNamesList } from 'models';
import { CONSTANTS } from 'utils';

const resultRequiredRoles = [
	RoleTypes.PRIMARY_ADMIN,
	RoleTypes.ADMIN,
	RoleTypes.CLIENT_USER,
	RoleTypes.PARTNER_USER,
];

export enum ResultPathList {
	results = '/results',
	dashboard = '/dashboard',
	summary = '/summary',
	comment = '/comment',
	service = '/service',
	persona = '/persona',
}

export const resultRoutes: IModuleRoute = {
	path: `${CONSTANTS.moduleAdminPath}${ResultPathList.results}`,
	name: AppRouteNamesList.result,
	requiredRoles: resultRequiredRoles,
	nested: [
		{
			path: `${ResultPathList.dashboard}/:surveyId`,
			name: AppRouteNamesList.dashboard,
			requiredRoles: resultRequiredRoles,
		},
		{
			path: `${ResultPathList.dashboard}/:surveyId${ResultPathList.summary}`,
			name: AppRouteNamesList.resultSummary,
			requiredRoles: resultRequiredRoles,
		},
		{
			path: `${ResultPathList.dashboard}/:surveyId${ResultPathList.comment}/:commentId`,
			name: AppRouteNamesList.commentPage,
			requiredRoles: resultRequiredRoles,
		},
		{
			path: `${ResultPathList.dashboard}/:surveyId${ResultPathList.service}`,
			name: AppRouteNamesList.servicePage,
			requiredRoles: resultRequiredRoles,
		},
		{
			path: `${ResultPathList.dashboard}/:surveyId${ResultPathList.persona}`,
			name: AppRouteNamesList.personasPage,
			requiredRoles: resultRequiredRoles,
		},
	],
};
